import type { MenuItemProps } from 'interfaces/navigation/Header';

export interface MenuItemResponse {
  id: string;
  label: string;
  url: string;
  parentId: string | null;
}

interface MenuNodes {
  nodes: {
    menuItems: {
      nodes: MenuItemResponse[];
      pageInfo?: {
        endCursor: string;
        hasNextPage: boolean;
      };
    };
  }[];
}

export interface MenuResponse {
  rightMenu: MenuNodes;
  rightMenu2: MenuNodes;
  rightRailMenu: MenuNodes;
  leftMenu: MenuNodes;
  topicNavigation: MenuNodes;
}

function findRecursive(menuItems: MenuItemProps[], id: string): MenuItemProps | null {
  let res = null;

  menuItems.forEach((menuItem) => {
    if (menuItem.id === id) {
      res = menuItem;
    } else if (menuItem.subMenu && res === null) {
      res = findRecursive(menuItem.subMenu, id);
    }
  });

  return res;
}

function buildMenuItemTree(menuItems: MenuItemResponse[]) {
  const result: MenuItemProps[] = [];
  const orphans: MenuItemResponse[] = [];

  menuItems.forEach((menuItem) => {
    if (menuItem.parentId === null) {
      result.push({ ...menuItem, subMenu: null });
    } else {
      const parent = findRecursive(result, menuItem.parentId);
      if (parent) {
        parent.subMenu = parent.subMenu || [];
        parent.subMenu.push({ ...menuItem, subMenu: null });
      } else {
        orphans.push(menuItem);
      }
    }
  });
  // the orphan check is to make sure order does not matter for menu items
  orphans.forEach((menuItem) => {
    const parent = findRecursive(result, menuItem.parentId!);
    if (parent) {
      parent.subMenu = parent.subMenu || [];
      parent.subMenu.push({ ...menuItem, subMenu: null });
    } else {
      throw new Error(`Parent menu item not found for ${menuItem.id}`);
    }
  });
  return result;
}

export default buildMenuItemTree;
